import Vue from 'vue'
export default {
  state: {
      club_parque: '',
      store_carrito: [],
      fecha_visita: '',
      subrouter: false
  },
  getters: {
    getClubParque (state) {
      return state.club_parque
    },
    doneTodos (state) {
      return state.store_carrito
    },
    getDateVisit (state) {
      return state.fecha_visita
    },
    totalPagar (state) {
      let suma = 0
      state.store_carrito.forEach(element => {
        suma += element.total
      });
      return suma.toFixed(2)
    },
    getSubRouter (state) {
        return state.subrouter
    }
  },
  mutations: {
      setCarrito(state, items) {
         Vue.set(state, 'store_carrito', [...items]);
          //state.store_carrito.push(cart)
      },
      setClubParque(state, name) {
          state.club_parque = name
      },
      setDateVisit(state, date) {
          state.fecha_visita = date
      },
      setSubRouter(state, name) {
          state.subrouter = name
      }
  },
  actions: {
      updateCarrito(context, items) {
        context.commit('setCarrito', items);
        //this.commit('setCarrito', mela)
      },
      updateClubParque(context, name) {
        context.commit('setClubParque', name);
      },
      updateDateVisit(context, date) {
        context.commit('setDateVisit', date);
      },
      updateSubRouter(context, name) {
        context.commit('setSubRouter', name)
      }
  },
}



// WEBPACK FOOTER //
// ./src/store/sale.module.js